export default {
  data() {
    return {
      tabBarHeight: 100,
      screenHeight: 0,
      headerHeight: 0,
      scrollBoxHeight: 0,
      bottomTabBarHeight: 0,
      // scrollOffset: 0
    }
  },
  beforeRouteLeave(to, form, next) {
    this.scrollOffset = document.getElementById('pageContent') ? document.getElementById('pageContent').scrollTop : 0
    next()
  },
  activated() {
    // 还原上次滚动的距离
    if (document.getElementById('pageContent')) {
      document.getElementById('pageContent').scrollTop = this.scrollOffset
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$route && this.getSystemInfo()
    })
  },
  methods: {
    getSystemInfo() {
      this.screenHeight = document.body.clientHeight
      this.headerHeight = document.querySelector('.header') && document.querySelector('.header').clientHeight
      this.bottomTabBarHeight = document.querySelector('.bottomTabBar') && (document.querySelector('.bottomTabBar').clientHeight)
      this.scrollBoxHeight = this.screenHeight - this.headerHeight - this.bottomTabBarHeight
    }
  }
}
